/**
 * Authentication utilities for token management
 */

const AUTH_TOKEN_KEY = "auth_token"

/**
 * Sets the authentication token in localStorage
 * @param token - The authentication token (in this demo, using email as token)
 */
export function setAuthToken(token: string): void {
  if (typeof window !== "undefined") {
    localStorage.setItem(AUTH_TOKEN_KEY, token)
  }
}

/**
 * Gets the authentication token from localStorage
 * @returns The authentication token or null if not found
 */
export function getAuthToken(): string | null {
  if (typeof window !== "undefined") {
    return localStorage.getItem(AUTH_TOKEN_KEY)
  }
  return null
}

/**
 * Removes the authentication token from localStorage
 */
export function removeAuthToken(): void {
  if (typeof window !== "undefined") {
    localStorage.removeItem(AUTH_TOKEN_KEY)
  }
}

/**
 * Checks if the user is authenticated
 * @returns true if token exists, false otherwise
 */
export function isAuthenticated(): boolean {
  return getAuthToken() !== null
}
